export default "__VITE_ASSET__CmQnzN5d__"